(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function TabbedQuiz(elem) {
        Behaviors.init(TabbedQuiz, this, arguments);

        var $thisElem = this.$elem,
            navItem = $thisElem.find('.TabbedQuiz-tabLinks a');

        function Filters(paged, term) {
            $.ajax({
                url: theme_ajax_url, // AJAX handler
                data: {
                    'action': 'quiz_filters',
                    paged: paged,
                    term: term
                },
                type: 'POST',
                beforeSend: function (xhr) {
                    $thisElem.addClass('TabbedQuiz-loading');
                },
                success: function (data) {
                    $thisElem.find('.TabbedQuiz-row').html(data);

                    $thisElem.removeClass('TabbedQuiz-loading');
                }
            });
            return false;
        }
        
        // Team Filters
        navItem.on("click", function (e) {
            e.preventDefault();
            // console.log("Clicked");
            var term = $(this).data('term');

            // Remove Active Class
            $('.TabbedQuiz-tabLinks__active').removeClass('TabbedQuiz-tabLinks__active');

            // Add Active Class
            $(this).parent().addClass('TabbedQuiz-tabLinks__active');


            Filters(1, term);
        }); 

        // Pagination
        $(document).on("click", '.TabbedQuiz .NF-NumberPagination a', function (e) {
            e.preventDefault();

            var $this = $(this),
                paged = $(this).text(),
                current = parseInt($thisElem.find('.NF-NumberPagination .current').text()),
                term = $thisElem.find('.TabbedQuiz-tabLinks__active a').data('term');

                // console.log(current); 
            if ($this.hasClass('prev')) {
                paged = parseInt(current - 1);
            } else if ($this.hasClass('next')) {
                paged = parseInt(current + 1);
            }

            Filters(paged, term);
        });
    }

    Behaviors.inherit(TabbedQuiz, Behaviors.Behavior);

    TabbedQuiz.QUERY = "[data-quiz-filters]";

    Behaviors.register_behavior(TabbedQuiz);

    module.TabbedQuiz = TabbedQuiz;

    return module;

}(window.jQuery, window.Behaviors));